import { ContactDto } from '../common/interfaces/ContactDto.interface';
import httpClient from './HttpClient';
import { createAxiosConfig } from './HttpClientUtil';

export class AtMentionsClient {
    public static async getContactsForAtMentions({
        viewId,
        rowId,
        reportSheetId,
        filter,
        isUnmaskedId,
    }: {
        viewId: string;
        rowId: number;
        reportSheetId?: number;
        filter?: string;
        isUnmaskedId?: boolean;
    }): Promise<ContactDto[]> {
        const config = createAxiosConfig({
            queryParams: {
                reportSheetId,
                isUnmaskedId,
                filter,
            },
        });

        const url = `/views/${viewId}/rows/${rowId}/atmentions/contacts`;

        const response = await httpClient.get<ContactDto[]>(url, config);
        return response.data;
    }
}
